var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgRealhubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0592 0.659908C14.5403 -0.219969 12.669 -0.219969 11.1501 0.659908L2.45458 5.6971C0.93568 6.57697 0 8.20306 0 9.96281V20.0372C0 21.7969 0.93568 23.423 2.45458 24.3029L11.1501 29.3401C12.669 30.22 14.5403 30.22 16.0592 29.3401L24.7547 24.3029C26.2736 23.423 27.2093 21.7969 27.2093 20.0372V9.96281C27.2093 8.20306 26.2736 6.57697 24.7547 5.6971L16.0592 0.659908ZM13.1549 7.61152C12.9398 7.61152 12.7281 7.62377 12.5197 7.6455C9.8143 7.92758 7.71436 9.98554 7.71436 12.4842V18.8607C7.72671 19.1784 8.01608 19.433 8.37361 19.433C8.5741 19.433 8.75165 19.3514 8.87317 19.2252L8.88836 19.2077C8.90133 19.1927 8.91432 19.1778 8.92765 19.163C9.92502 18.0613 11.448 17.3567 13.1549 17.3567C16.1595 17.3567 18.5952 15.1753 18.5952 12.4842C18.5952 9.79294 16.1595 7.61152 13.1549 7.61152ZM9.77925 22.0098C10.7817 20.4786 12.3121 19.4989 14.0279 19.4989C15.1008 19.4989 16.1015 19.1164 16.9459 18.4552C17.2108 18.2477 17.625 18.3504 17.752 18.662C18.1021 19.5203 18.5949 20.2741 19.1929 20.8748C19.2067 20.8885 19.2209 20.9021 19.235 20.9157C19.2442 20.9246 19.2534 20.9334 19.2625 20.9423C19.4042 21.0933 19.4957 21.3143 19.4957 21.5642C19.4957 22.0092 19.21 22.3695 18.8537 22.3848H11.6978C11.0463 22.3848 10.6479 22.3862 10.3681 22.3872C10.2362 22.3877 10.1307 22.388 10.0375 22.3881H9.9925C9.86659 22.3881 9.85138 22.3881 9.72427 22.3035C9.65763 22.2591 9.71333 22.1131 9.72427 22.096C9.74267 22.0672 9.76063 22.0383 9.77925 22.0098Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealhubLogo);
export default __webpack_public_path__ + "static/media/realhub-logo.4326d6102d9c74c28cf5f0acf2d871d7.svg";
export { ForwardRef as ReactComponent };